/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationStatusDto } from '../../models/application-status-dto';

export interface ApplicationAdminControllerUpdateStatusV1$Params {
  id: string;
      body: ApplicationStatusDto
}

export function applicationAdminControllerUpdateStatusV1(http: HttpClient, rootUrl: string, params: ApplicationAdminControllerUpdateStatusV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, applicationAdminControllerUpdateStatusV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

applicationAdminControllerUpdateStatusV1.PATH = '/api/v1/applications/admin/{id}/status';
